import { ADD_TO_CART, ADD_TO_CART_UNAVAILABLE, OPEN_CONFIGURATOR, OPEN_CONFIGURATOR_UNAVAILABLE } from './actions.js';
import { SINGLE_PURCHASE, SUBSCRIPTION_PURCHASE } from './bloomreach.js';
import { RECOVERABLE_ERROR, NONRECOVERABLE_ERROR } from './generic-query-errors.js';

function isSinglePurchase(purchaseType) {
    return purchaseType === SINGLE_PURCHASE;
}
function isSubscriptionPurchase(purchaseType) {
    return purchaseType === SUBSCRIPTION_PURCHASE;
}
function isRecoverableError(errorType) {
    return errorType === RECOVERABLE_ERROR;
}
function isNonRecoverableError(errorType) {
    return errorType === NONRECOVERABLE_ERROR;
}
function isRegularProductAction(action) {
    return action === ADD_TO_CART || action === ADD_TO_CART_UNAVAILABLE;
}
function isRxProductAction(action) {
    return action === OPEN_CONFIGURATOR || action === OPEN_CONFIGURATOR_UNAVAILABLE;
}

export { isNonRecoverableError, isRecoverableError, isRegularProductAction, isRxProductAction, isSinglePurchase, isSubscriptionPurchase };
//# sourceMappingURL=typeguards.js.map
